import ResponsiveImage from './ResponsiveImage'

export default function MediaStrip({ eyebrow = 'CRS / En campo', items }) {
  return (
    <section className="media-strip" aria-label="Registro fotográfico de obra">
      <div className="media-strip-heading" data-reveal>
        <p className="eyebrow">{eyebrow}</p>
        <p>Maquinaria, especialistas y ejecución documentados en proyectos reales.</p>
      </div>
      <div className="media-strip-grid">
        {items.slice(0, 3).map((item, index) => (
          <figure className={`media-frame media-frame-${index + 1}`} key={item.name} data-reveal>
            <ResponsiveImage name={item.name} alt={item.alt} sizes="(min-width: 900px) 34vw, 100vw" />
            <figcaption><span>0{index + 1}</span>{item.label}</figcaption>
          </figure>
        ))}
      </div>
    </section>
  )
}
